<main class="p-7 space-y-8">
    <!-- Header -->
    <div class="flex items-center justify-between">
        <div>
            <button (click)="goBack()" class="mb-4 inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold text-sm">
                <span class="material-symbols-outlined text-[20px]">arrow_back</span>
                Back to Dashboard
            </button>
            <p class="text-sm font-medium uppercase tracking-[0.18em] text-slate-500">User Profile</p>
            <h1 class="mt-2 text-3xl font-bold text-slate-900">Your Account Information</h1>
            <p class="mt-3 max-w-2xl text-sm text-slate-600">Manage your profile details and account settings.</p>
        </div>
    </div>

    <div *ngIf="isLoading"
        class="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm font-semibold text-blue-700">
        Loading user profile...
    </div>

    <div *ngIf="errorMessage"
        class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">
        {{ errorMessage }}
    </div>

    <!-- Profile Cards Grid -->
    <div class="grid gap-6 lg:grid-cols-3">
        <!-- Main Profile Card -->
        <div class="lg:col-span-2 rounded-[28px] border border-slate-200 bg-white p-8 shadow-sm">
            <div class="flex items-start justify-between mb-8">
                <div>
                    <p class="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">Account Details</p>
                    <h2 class="mt-2 text-2xl font-bold text-slate-900">Profile Information</h2>
                </div>
                <button *ngIf="!isEditing" (click)="startEditing()" class="inline-flex items-center gap-2 rounded-2xl bg-blue-900 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800 transition">
                    <span class="material-symbols-outlined">edit</span>
                    Edit Profile
                </button>
            </div>

            <!-- Profile Form -->
            <div class="space-y-6">
                <div class="grid gap-4 md:grid-cols-2">
                    <div>
                        <label class="block text-sm font-semibold text-slate-700 mb-2">First Name</label>
                        <input 
                            [disabled]="!isEditing"
                            [(ngModel)]="editFirstName"
                            type="text" 
                            class="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition disabled:bg-slate-50 disabled:text-slate-600 disabled:cursor-not-allowed"
                            placeholder="Enter first name">
                    </div>

                    <div>
                        <label class="block text-sm font-semibold text-slate-700 mb-2">Last Name</label>
                        <input 
                            [disabled]="!isEditing"
                            [(ngModel)]="editLastName"
                            type="text" 
                            class="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition disabled:bg-slate-50 disabled:text-slate-600 disabled:cursor-not-allowed"
                            placeholder="Enter last name">
                    </div>
                </div>

                <div>
                    <label class="block text-sm font-semibold text-slate-700 mb-2">Email Address</label>
                    <input 
                        [disabled]="!isEditing"
                        [(ngModel)]="editEmail"
                        type="email" 
                        class="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition disabled:bg-slate-50 disabled:text-slate-600 disabled:cursor-not-allowed"
                        placeholder="Enter email address">
                </div>

                <div class="grid gap-4 md:grid-cols-2">
                    <div>
                        <label class="block text-sm font-semibold text-slate-700 mb-2">Phone Number</label>
                        <input 
                            [disabled]="!isEditing"
                            [(ngModel)]="editPhoneNumber"
                            type="text" 
                            class="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition disabled:bg-slate-50 disabled:text-slate-600 disabled:cursor-not-allowed"
                            placeholder="Enter phone number">
                    </div>

                    <div>
                        <label class="block text-sm font-semibold text-slate-700 mb-2">Date of Birth</label>
                        <input 
                            [disabled]="!isEditing"
                            [(ngModel)]="editDateOfBirth"
                            type="date" 
                            class="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition disabled:bg-slate-50 disabled:text-slate-600 disabled:cursor-not-allowed">
                    </div>
                </div>

                <div>
                    <label class="block text-sm font-semibold text-slate-700 mb-2">Address</label>
                    <textarea
                        [disabled]="!isEditing"
                        [(ngModel)]="editAddress"
                        rows="3"
                        class="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white text-slate-900 placeholder-slate-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition disabled:bg-slate-50 disabled:text-slate-600 disabled:cursor-not-allowed"
                        placeholder="Enter address"></textarea>
                </div>

                <div>
                    <label class="block text-sm font-semibold text-slate-700 mb-2">Role</label>
                    <input 
                        disabled
                        [value]="roleName"
                        type="text" 
                        class="w-full px-4 py-3 rounded-lg border border-slate-200 bg-slate-50 text-slate-600 cursor-not-allowed"
                        placeholder="Role">
                </div>

                <!-- Action Buttons -->
                <div *ngIf="isEditing" class="flex gap-3 pt-4">
                    <button 
                        (click)="saveProfile()"
                        [disabled]="isSaving"
                        class="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-blue-900 px-4 py-3 text-sm font-semibold text-white hover:bg-blue-800 transition disabled:opacity-50 disabled:cursor-not-allowed">
                        <span class="material-symbols-outlined">check</span>
                        {{ isSaving ? 'Saving...' : 'Save Changes' }}
                    </button>
                    <button 
                        (click)="cancelEditing()"
                        class="flex-1 inline-flex items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition">
                        <span class="material-symbols-outlined">close</span>
                        Cancel
                    </button>
                </div>
            </div>
        </div>

        <!-- Info Sidebar -->
        <div class="space-y-4">
            <!-- Account Status Card -->
            <div class="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
                <p class="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500 mb-4">Account Status</p>
                <div class="space-y-4">
                    <div class="rounded-2xl bg-emerald-50 p-4 border border-emerald-200">
                        <p class="text-xs font-semibold uppercase tracking-[0.1em] text-emerald-700 mb-1">Status</p>
                        <p class="text-lg font-bold text-emerald-900">{{ isEnabled ? 'Active' : 'Inactive' }}</p>
                    </div>
                    <div class="rounded-2xl bg-blue-50 p-4 border border-blue-200">
                        <p class="text-xs font-semibold uppercase tracking-[0.1em] text-blue-700 mb-1">Role Level</p>
                        <p class="text-lg font-bold text-blue-900">{{ roleId }}</p>
                    </div>
                    <div class="rounded-2xl bg-slate-50 p-4 border border-slate-200">
                        <p class="text-xs font-semibold uppercase tracking-[0.1em] text-slate-600 mb-1">Two Factor</p>
                        <p class="text-lg font-bold text-slate-900">{{ is2FAEnabled ? 'Enabled' : 'Disabled' }}</p>
                    </div>
                </div>
            </div>

            <!-- Activity Card -->
            <div class="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
                <p class="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500 mb-4">Activity</p>
                <div class="space-y-3 text-sm">
                    <div>
                        <p class="text-xs text-slate-500 uppercase tracking-[0.1em] mb-1">Account Created</p>
                        <p class="font-semibold text-slate-900">{{ createdAt }}</p>
                    </div>
                    <div>
                        <p class="text-xs text-slate-500 uppercase tracking-[0.1em] mb-1">Last Login</p>
                        <p class="font-semibold text-slate-900">{{ lastLogin }}</p>
                    </div>
                </div>
            </div>

            <!-- Security Card -->
            <div class="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
                <p class="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500 mb-4">Security</p>
                <button 
                    (click)="changePassword()"
                    class="w-full inline-flex items-center justify-center gap-2 rounded-lg border border-orange-200 bg-orange-50 px-4 py-3 text-sm font-semibold text-orange-700 hover:bg-orange-100 transition">
                    <span class="material-symbols-outlined">lock</span>
                    Change Password
                </button>
            </div>
        </div>
    </div>
</main>
